module.exports = __webpack_public_path__ + "static/media/pentagon-1.c321f0b6.svg";